import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Modal, Button, Input } from 'shpmtcd'

import { validateConfirmedPassword, validatePassword } from '../../utils/validations'
import ForgotPassword from '../../Account/containers/ForgotPassword'
import FeedbackAction from '../../shared/actionFeedback/container'

const initialState = {
  currentPwd: '',
  newPwd: '',
  confirmNewPwd: '',
  newPwdValidation: {
    isValid: true,
    validationMessages: '',
  },
  confirmNewPwdValidation: {
    isValid: true,
    validationMessages: '',
  },
  showForgotPwd: false,
}
class ChangePassword extends Component {
  constructor(props) {
    super(props)
    this.state = {
      ...initialState,
    }
  }

  componentDidUpdate(prevProps) {
    const { visible } = this.props
    if (prevProps.visible !== visible) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        ...initialState,
      })
    }
  }

  handleInputs = (e, stateName) => {
    this.setState({
      [stateName]: e.target.value,
    })

    const { newPwd } = this.state
    let stateValidation = null
    if (stateName === 'newPwd') {
      stateValidation = {
        key: 'newPwdValidation',
        value: validatePassword(e.target.value),
      }
    }
    if (stateName === 'confirmNewPwd') {
      stateValidation = {
        key: 'confirmNewPwdValidation',
        value: validateConfirmedPassword(e.target.value, {
          value: newPwd,
        }),
      }
    }
    if (stateValidation) {
      this.setState({
        [stateValidation.key]: stateValidation.value,
      })
    }
  }

  handleCloseModal = () => {
    const { closeModal } = this.props

    this.setState({
      ...initialState,
    })
    closeModal()
  }

  handleForgotPwd = () => {
    const { showForgetPwdModal } = this.props
    this.setState({
      ...initialState,
      showForgotPwd: true,
    })
    showForgetPwdModal()
  }

  handleBackTo = () => {
    this.setState({
      showForgotPwd: false,
    })
  }

  handleChangePwdSubmit = () => {
    const { currentPwd, newPwd, confirmNewPwd } = this.state
    const { onSubmit } = this.props
    const params = {
      current_password: currentPwd,
      new_password: newPwd,
      confirm_new_password: confirmNewPwd,
    }
    onSubmit(params)
  }

  // eslint-disable-next-line react/destructuring-assignment
  footerComponets = () => (this.state.showForgotPwd ? [
    <Button
      key='changePassword'
      type='Text'
      className='footer-forgotPassword-link'
      onClick={this.handleBackTo}
    >
      Back to Change Password
    </Button>,
  ]
    : [
      <Button
        key='forgotPassword'
        type='Text'
        className='footer-forgotPassword-link'
        onClick={this.handleForgotPwd}
      >
        Forgot Password
      </Button>,
    ]
  )

  enablePwdButton = () => {
    const {
      currentPwd, newPwd, confirmNewPwd, newPwdValidation, confirmNewPwdValidation,
    } = this.state
    let enablePwdButton = false
    if (currentPwd.length && newPwd.length && confirmNewPwd.length) {
      enablePwdButton = newPwdValidation.isValid && confirmNewPwdValidation.isValid
    }
    return enablePwdButton
  }

  render() {
    const { visible, apiActionFeedback } = this.props
    const {
      currentPwd, newPwd, confirmNewPwd, newPwdValidation, confirmNewPwdValidation, showForgotPwd,
    } = this.state

    const enablePwdButton = this.enablePwdButton()

    return (
      <Modal
        title=''
        width={360}
        wrapClassName='vertical-center-modal changePwd-modal'
        visible={visible}
        onCancel={this.handleCloseModal}
        footer={this.footerComponets()}
      >
        <section className='modal-body-wrapper'>
          {
          showForgotPwd ? <ForgotPassword footerLink={{}} />
            : (
              <div className='changePwd-wrapper'>
                <div className='title'>Change Password</div>
                <Input
                  value={currentPwd}
                  type='password'
                  label='Current password'
                  autoComplete='new-password'
                  onChange={(e) => this.handleInputs(e, 'currentPwd')}
                />
                <Input
                  value={newPwd}
                  type='password'
                  label='New password'
                  error={newPwdValidation.validationMessages.toString()}
                  onChange={(e) => this.handleInputs(e, 'newPwd')}
                />
                <Input
                  value={confirmNewPwd}
                  type='password'
                  label='Confirm new password'
                  error={confirmNewPwdValidation.validationMessages.toString()}
                  onChange={(e) => this.handleInputs(e, 'confirmNewPwd')}
                />

                { apiActionFeedback && <FeedbackAction /> }

                <Button
                  type='Primary'
                  disabled={!enablePwdButton}
                  onClick={this.handleChangePwdSubmit}
                  block
                >
                  Change Password
                </Button>
              </div>
            )
  }
        </section>
      </Modal>
    )
  }
}

ChangePassword.propTypes = {
  visible: PropTypes.bool.isRequired,
  apiActionFeedback: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  showForgetPwdModal: PropTypes.func.isRequired,
}

export default ChangePassword
